import { useRef } from "react";
import { motion } from "framer-motion";
import Home from "../Home";
import styles from "./HomeWrapper.module.css";

const HomeWrapper = () => {
  const guideRef = useRef(null);

  const scrollToGuide = () => {
    guideRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.wrapper}>
      <motion.section
        className={styles.homeSection}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Home scrollToGuide={scrollToGuide} />
      </motion.section>
    </div>
  );
};

export default HomeWrapper;
